








































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SkalaNyeriNew from "@/components/pemeriksaan/assesmen/SkalaNyeriNew.vue";
import Lokasi from "@/components/pemeriksaan/assesmen/Lokasi.vue";
import Durasi from "@/components/pemeriksaan/assesmen/Durasi.vue";
import Frekuensi from "@/components/pemeriksaan/assesmen/Frekuensi.vue";
import Pencetus from "@/components/pemeriksaan/assesmen/Pencetus.vue";
import KualitasNyeri from "@/components/pemeriksaan/assesmen/KualitasNyeri.vue";
import PolaSerangan from "@/components/pemeriksaan/assesmen/PolaSerangan.vue";
import PenyebabNyeriHilang from "@/components/pemeriksaan/assesmen/PenyebabNyeriHilang.vue";
import JenisNyeri from "@/components/pemeriksaan/assesmen/JenisNyeri.vue";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
// import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import { userModule } from "@/store/modules/user";
import AsesNyeriSvc from "@/services/AsesmenNyeri";
import { appModule } from "@/store/modules/app";
import { storeNyeri } from "@/store/modules/nyeri";
import moment from "moment";
import storeRefAsesmen from "@/store/modules/new/ReferensiAsesmen";
import {
  intervensiNyeri,
  IntervensiNyeri
} from "@/utils/nyeriIntervensi";

@Component({
  components: {
    SkalaNyeriNew,
    Lokasi,
    Durasi,
    Frekuensi,
    Pencetus,
    KualitasNyeri,
    PolaSerangan,
    PenyebabNyeriHilang,
    JenisNyeri
    // PerawatAutoComplete
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AsesmenNyeri extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() nyeri!: object;
  @Prop({ default: "normal" }) mode: "attach" | "normal";

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  hideSkala = false;

  metode = null;

  setSkalaNyeri(val) {
    if (val > 0) {
      this.hideSkala = true;
      if (this.jenis == "0") {
        this.jenis = "1";
      }
    } else {
      this.hideSkala = false;
    }
    this.skala = val;
  }

  setLokasi(val) {
    this.lokasi = val;
  }
  setDurasi(val) {
    this.durasi = val;
  }
  setFrekuensi(val) {
    this.frekuensi = val;
  }
  setPencetus(val) {
    this.pencetus = val;
  }
  setKualitasNyeri(val) {
    this.kualitas = val;
  }
  setPolaSerangan(val) {
    this.pola_serangan = val;
  }
  setPenyebabNyeriHilang(val) {
    this.penyebab_hilang = val;
  }
  setJenisNyeri(val) {
    this.jenis = val;
  }

  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }

  get intervensi(): IntervensiNyeri | null {
    return intervensiNyeri(this.metode, this.skala);
  }

  mounted() {
    if (userModule.user.unit_id >= "01" && userModule.user.unit_id < "50") {
      this.metode = "nrs";
    }
  }

  radioNyeri = true;
  colSkala = "";
  warna = "green";
  textSkala = null;
  rangeSkala = ["0", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  selectProps = { openOnHover: true, offsetY: true };

  categVal = {
    nips: {},
    flacc: {},
    bps: {}
  };

  get categoryNIPS() {
    return storeRefAsesmen.nyeriNIPS;
  }

  get categoryFLACC() {
    return storeRefAsesmen.nyeriFLACC;
  }

  get categoryBPS() {
    return storeRefAsesmen.nyeriBPS;
  }

  get metodeInput() {
    if (this.metode == "nips") {
      return this.categoryNIPS;
    }

    if (this.metode == "flacc") {
      return this.categoryFLACC;
    }

    if (this.metode == "bps") {
      return this.categoryBPS;
    }

    return [];
  }

  get totalScore() {
    const cVal = this.categVal[this.metode]
      ? Object.entries(this.categVal[this.metode])
      : [];

    const score =
      this.metode &&
      this.metode !== "nrs" &&
      cVal.length === this.metodeInput.length &&
      cVal.every(it => it[1] !== null)
        ? cVal.map(i => i[1]["scoring"]).reduce((a, b) => a + b, 0)
        : null;

    this.skala = score;

    return score;
  }

  @Watch("skala")
  changeNyeri(val) {
    if (val > 0) {
      this.hideSkala = true;
      // console.log(">0");
    } else {
      // console.log("=0");
      this.hideSkala = false;
    }

    if (val === 0) {
      this.warna = "green";
      this.textSkala = "Tidak Nyeri";
    } else if (val && val < 4) {
      this.warna = "#FBC02D";
      this.textSkala = "Nyeri Ringan";
    } else if (val && val < 7) {
      this.warna = "#F57C00";
      this.textSkala = "Nyeri Sedang";
    } else if (val && val >= 7) {
      this.warna = "#DD2C00";
      this.textSkala = "Nyeri Berat";
    } else {
      this.warna = null;
      this.textSkala = "-";
    }
  }

  @Watch("nyeri", { deep: true })
  changeNyeriForEdit(val) {
    console.log("change nyeri @Watch", val);

    if (val) {
      this.metode = val.metode;

      // trik sementara buat ngakalin watch metode
      setTimeout(() => {
        this.id = val.id;
        this.skala = val.skala;
        this.lokasi = val.lokasi;
        this.intensitas = val.intensitas;
        this.durasi = val.durasi;
        this.frekuensi = val.frekuensi;
        this.pencetus = val.pencetus;
        this.kualitas = val.kualitas;
        this.pola_serangan = val.pola_serangan;
        this.penyebab_hilang = val.penyebab_hilang;
        this.jenis = val.jenis;
        this.examinedAt = new Date(val.examined_at);

        if (val.question.length > 0) {
          const quest: Array<any> = JSON.parse(JSON.stringify(val.question));
          const itm = {};

          quest.forEach(it => {
            if (it.ref_group_id) {
              itm[it.ref_group_id] = this[
                `category${this.metode.toUpperCase()}`
              ]
                .find(cat => cat.id == it.ref_group_id)
                ?.val.find(val => val.id == it.ref_id);
            }
          });

          this.categVal[val.metode] = itm;

          console.log("set input", this.categVal[val.metode], itm);
        }
      }, 500);
    } else {
      this.createNew();
    }
  }

  @Watch("totalScore", { deep: true })
  changeTotalScore(val) {
    this.skala = val;
    console.log("change total score", val, this.skala);
  }

  @Watch("metode")
  changeMetode(val, oldVal) {
    console.log("change metode", val, oldVal);

    if (val) {
      if (val !== oldVal) {
        this.skala = null;
      }

      this.categVal[val] = {};
      // this.question = null;
      this.id = null;
    }
  }

  saving = false;

  get sessLogin() {
    return userModule.user;
  }

  skala = null;
  lokasi = null;
  intensitas = null;
  durasi = null;
  frekuensi = null;
  pencetus = null;
  kualitas = null;
  pola_serangan = null;
  penyebab_hilang = null;
  jenis = null;
  // question = null;
  id = null;
  examinedAt: string | Date = new Date();

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };

  get question() {
    let quest = null;

    if (this.metode != "nrs") {
      quest = Object.entries(this.categVal[this.metode]).map(i => {
        return i[1]
          ? {
              ref_group_id: parseInt(i[0]),
              ref_id: i[1]["id"],
              skor: i[1]["scoring"]
            }
          : null;
      });
    } else {
      quest = null;
    }

    return quest;
  }

  get params() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.sessLogin.unit_id,
      metode: this.metode,
      skala: this.skala,
      lokasi: this.lokasi,
      intensitas: this.intensitas,
      durasi: this.durasi,
      frekuensi: this.frekuensi,
      pencetus: this.pencetus,
      kualitas: this.kualitas,
      pola_serangan: this.pola_serangan,
      penyebab_hilang: this.penyebab_hilang,
      jenis: this.jenis,
      question: this.question,
      user_id: this.sessLogin?.id,
      examined_at: moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss")
    };
  }

  async simpan() {
    if (this.readOnly) return;
    if (!this.metode) {
      return false;
    }

    if (this.params.question) {
      const cVal = this.categVal[this.metode]
        ? Object.entries(this.categVal[this.metode])
        : [];

      if (
        cVal.length !== this.metodeInput.length ||
        cVal.every(it => it[1] === null)
      ) {
        // alert(`Isian ${unfilled.map(it => it.title).join(", ")} harus diisi!`);
        alert(`Isian Instrumen Nyeri harus semua terisi!`);
        return false;
      }
    }

    if (!this.saving) {
      this.saving = true;

      const getUnitReg = {
        unit_id: this.sessLogin.unit_id,
        reg: this.register
      };

      const SaveNyeri = this.id
        ? AsesNyeriSvc.update(this.id, this.params)
        : AsesNyeriSvc.create(this.params);

      return await SaveNyeri.then(resp => {
        console.log("save response", resp);
        if (resp["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          if (this.mode === "normal") {
            this.createNew();
            appModule.NoticeDelay("Berhasil Simpan Asesmen Nyeri");
            storeNyeri.actNyeriByRm(this.rm);
          }

          this.id = resp.data.id;
          storeNyeri.actNyeriByReg(getUnitReg);
        }

        return resp;
      })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          appModule.setLoading(false);
          this.saving = false;
        });
    } else {
      return false;
    }
  }

  createNew() {
    this.id = null;
    this.metode = null;
    this.skala = null;
    this.lokasi = null;
    this.intensitas = null;
    this.durasi = null;
    this.frekuensi = null;
    this.pencetus = null;
    this.kualitas = null;
    this.pola_serangan = null;
    this.penyebab_hilang = null;
    this.jenis = null;
    // this.question = null;
    this.examinedAt = new Date();

    this.$emit("create-new");
  }
}
